export default {
  "expandable": "_expandable_qltwbf",
  "text-area": "_text-area_qltwbf"
};